import { render, staticRenderFns } from "./MenuSetup.vue?vue&type=template&id=072a8fd6&scoped=true&"
import script from "./MenuSetup.vue?vue&type=script&lang=js&"
export * from "./MenuSetup.vue?vue&type=script&lang=js&"
import style0 from "./MenuSetup.vue?vue&type=style&index=0&id=072a8fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a8fd6",
  null
  
)

export default component.exports